module.exports = __webpack_public_path__ + "img/momo_index_point.ec78d891.png";